<section class="layout-designer">
	<aside class="properties-panel">
		<header class="panel-header">
			<div>
				<h2>Diseñador de layout</h2>
				<p>Distribución porcentual para pantallas 16:9.</p>
			</div>
		</header>

		<label class="field">
			<span>Nombre del layout</span>

			<input
				#layoutNameInput
				type="text"
				[value]="layoutName"
				placeholder="Ej. Layout principal"
				maxlength="100"
				(input)="layoutName = layoutNameInput.value"
			/>
		</label>

		<div class="actions">
			<button type="button" class="primary-button" (click)="addElement()">
				Agregar zona
			</button>

			<button
				type="button"
				(click)="duplicateSelected()"
				[disabled]="!selectedElement"
			>
				Duplicar
			</button>

			<button
				type="button"
				class="danger-button"
				(click)="removeSelected()"
				[disabled]="!selectedElement"
			>
				Eliminar
			</button>
			<button
				type="button"
				class="save-button"
				(click)="saveLayout()"
				[disabled]="elements.length === 0 || !layoutName.trim()"
			>
				Guardar layout
			</button>
		</div>

		<div *ngIf="errorMessage" class="validation-message" role="alert">
			{{ errorMessage }}
		</div>

		<section
			*ngIf="selectedElement as selected; else emptySelection"
			class="element-properties"
		>
			<header>
				<h3>Propiedades de la zona</h3>
				<p>Todos los valores se expresan en porcentaje.</p>
			</header>

			<label class="field">
				<span>Nombre</span>

				<input
					#nameInput
					type="text"
					[value]="selected.name"
					(change)="updateName(nameInput.value)"
				/>
			</label>

			<label class="field">
				<span>Tipo de espacio</span>

				<select
					#typeSelect
					[value]="selected.type"
					(change)="updateType(typeSelect.value)"
				>
					<option
						*ngFor="let option of layoutTypeOptions"
						[value]="option.value"
					>
						{{ option.label }}
					</option>
				</select>
			</label>

			<label class="checkbox-field">
				<input
					#fixedSizeInput
					type="checkbox"
					[checked]="selected.fixedSize"
					(change)="updateFixedSize(fixedSizeInput.checked)"
				/>

				<span>Tamaño fijo</span>
			</label>

			<p class="field-description">
				Evita que este panel sea redimensionado automáticamente por
				otros paneles.
			</p>

			<div class="properties-grid">
				<label class="field">
					<span>Posición X</span>

					<div class="percentage-input">
						<input
							#xInput
							type="number"
							min="0"
							max="100"
							step="0.1"
							[value]="selected.x"
							(change)="
								updateNumericField('x', xInput.value, xInput)
							"
						/>

						<span>%</span>
					</div>
				</label>

				<label class="field">
					<span>Posición Y</span>

					<div class="percentage-input">
						<input
							#yInput
							type="number"
							min="0"
							max="100"
							step="0.1"
							[value]="selected.y"
							(change)="
								updateNumericField('y', yInput.value, yInput)
							"
						/>

						<span>%</span>
					</div>
				</label>

				<label class="checkbox-field">
					<input
						#aspectRatioInput
						type="checkbox"
						[checked]="selected.lockAspectRatio"
						(change)="
							updateAspectRatioLock(aspectRatioInput.checked)
						"
					/>

					<span>Bloquear proporción</span>
				</label>

				<p class="field-description">
					Al redimensionar, el ancho y el alto cambiarán manteniendo
					la forma actual.
				</p>

				<label class="field">
					<span>Ancho</span>

					<div class="percentage-input">
						<input
							#widthInput
							type="number"
							min="5"
							max="100"
							step="0.1"
							[value]="selected.width"
							(change)="
								updateNumericField(
									'width',
									widthInput.value,
									widthInput
								)
							"
						/>

						<span>%</span>
					</div>
				</label>

				<label class="field">
					<span>Alto</span>

					<div class="percentage-input">
						<input
							#heightInput
							type="number"
							min="5"
							max="100"
							step="0.1"
							[value]="selected.height"
							(change)="
								updateNumericField(
									'height',
									heightInput.value,
									heightInput
								)
							"
						/>

						<span>%</span>
					</div>
				</label>
			</div>
		</section>

		<ng-template #emptySelection>
			<div class="empty-selection">
				Seleccione una zona para consultar o modificar sus propiedades.
			</div>
		</ng-template>

		<section class="layout-summary">
			<span>Zonas creadas</span>
			<strong>{{ elements.length }}</strong>
		</section>
	</aside>

	<main class="designer-workspace">
		<header class="workspace-header">
			<div>
				<h2>Vista previa</h2>
				<p>Arrastre las zonas o utilice los controles de sus bordes.</p>
			</div>

			<span class="aspect-ratio-label">16:9</span>
		</header>

		<div class="canvas-container">
			<div
				#canvas
				class="layout-canvas"
				(pointerdown)="onCanvasPointerDown($event)"
				(pointermove)="onPointerMove($event)"
				(pointerup)="onPointerEnd($event)"
				(pointercancel)="onPointerEnd($event)"
			>
				<article
					*ngFor="let element of elements; trackBy: trackByElementId"
					class="layout-element"
					[class.selected]="selectedId === element.id"
					[style.left]="element.x + '%'"
					[style.top]="element.y + '%'"
					[style.width]="element.width + '%'"
					[style.height]="element.height + '%'"
					(pointerdown)="startMove($event, element)"
				>
					<div class="element-information">
						<strong>{{ element.name }}</strong>

						<span class="element-type">
							{{ getTypeLabel(element.type) }}
						</span>

						<span>
							{{ element.width | number: "1.0-1" }}% ×
							{{ element.height | number: "1.0-1" }}%
						</span>
					</div>

					<ng-container *ngIf="selectedId === element.id">
						<span
							*ngFor="
								let handle of resizeHandles;
								trackBy: trackByHandle
							"
							class="resize-handle"
							[ngClass]="'handle-' + handle"
							[attr.data-handle]="handle"
							(pointerdown)="startResize($event, element, handle)"
						></span>
					</ng-container>
				</article>

				<div *ngIf="elements.length === 0" class="empty-canvas">
					<strong>Layout vacío</strong>

					<span> Agregue una zona para comenzar a diseñar. </span>
				</div>
			</div>
		</div>

		<footer class="workspace-footer">
			<span> Posiciones y dimensiones almacenadas en porcentaje. </span>

			<span>Resolución de referencia: 1920 × 1080</span>
		</footer>
	</main>
</section>
